module.exports = __webpack_public_path__ + "img/Collegium_White.6351059d.svg";